import React, { useState, useEffect } from "react";

import axios from "axios";
import { useParams, useHistory } from "react-router-dom";

import { Configs } from "../api";

const EditTodo = () => {
  let history = useHistory();
  const id = useParams({});
  const [name, setname] = useState("");

  const adddata = async (e) => {
    try {
      console.log(name);
      const result = await axios.post(Configs.tip + "/" + id.id, {
        price: name,
      });
      // console.log(result);
      history.push("/dashboard/tips");
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    const dataID = async () => {
      try {
        const result = await axios.get(Configs.tip + "/" + id.id);
        setname(result.data.tip.price);
        // console.log(result.data.tip.price);
      } catch (error) {
        console.log(error.message);
      }
    };

    dataID();
  }, [id.id]);

  return (
    <div className="container-fluid box-styl">
      <h1 className="text-center mt-5">Locations</h1>
      <form
        className="d-flex mt-5 mb-5 algnItm"
        onSubmit={(e) => {
          adddata(e);
        }}
      >
        <input
          type="text"
          className="form-control input-styl"
          value={name}
          onChange={(e) => setname(e.target.value)}
        ></input>
        <button className="btn btn-success">Edit</button>
      </form>
    </div>
  );
};

export default EditTodo;
